import { render, staticRenderFns } from "./create-store-manage.vue?vue&type=template&id=a2ab98cc&scoped=true&"
import script from "./create-store-manage.vue?vue&type=script&lang=js&"
export * from "./create-store-manage.vue?vue&type=script&lang=js&"
import style0 from "./create-store-manage.vue?vue&type=style&index=0&id=a2ab98cc&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ab98cc",
  null
  
)

export default component.exports